import { useEffect, useState } from "react";
import { db, DocumentData, DocumentReference } from "api/firebase";
import { IExhibitorPair } from "@evennt-tech/api-v2-core";
import { unpackDocs } from "tools/common/unpackDocs";

const useUserConversations = (
  showId: string,
  exhibitorPair?: IExhibitorPair | string
) => {
  const [docRef, setDocRef] = useState<DocumentReference<DocumentData> | null>(
    null
  );
  const [conversations, setConversations] = useState<any | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    let ref: DocumentReference<DocumentData> | null = null;

    if (typeof exhibitorPair === "string") {
      ref = db
        .collection("shows")
        .doc(showId)
        .collection("standsConversations")
        .doc("organisers");
    } else if (typeof exhibitorPair === "object" && exhibitorPair?.stand) {
      ref = db
        .collection("shows")
        .doc(showId)
        .collection("standsConversations")
        .doc(exhibitorPair.stand.standId);
    }

    setDocRef(ref);
  }, [exhibitorPair, showId]);

  useEffect(() => {
    if (!docRef) {
      setConversations(null);
      setLoading(false);
      return;
    }

    setLoading(true);

    const unsubscribe = docRef.onSnapshot(
      (docSnap) => {
        setConversations(docSnap.exists ? unpackDocs(docSnap) : null);
        setLoading(false);
        setError(null);
      },
      (err: Error) => {
        setError(err);
        setLoading(false);
      }
    );

    return () => {
      unsubscribe();
    };
  }, [docRef]);

  return { conversations, loading, error };
};

export default useUserConversations;
